














import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import conditionList from './json/conditionList.json'

export default Vue.extend({
    props: ['barId'],
    watch: {
        barId() {
            const data = conditionList as any
            this.dataList = data[this.barId].data
            this.check = false
            const params = {check: this.check, data: {}}
            this.$emit('checkCondition', params)
        },
    },
    data() {
        return {
            dataList: [] as any,
            check: false,
            checkText: '',
        }
    },
    created() {
        const data = conditionList as any
        this.dataList = data[this.barId].data
    },
    methods: {
        checked() {
            this.check = false
            this.checkText = ''
            const params = {check: this.check, data: {}}
            this.$emit('checkCondition', params)
        },
        checkCondtion(item: any) {
            this.check = true
            this.checkText = item.text
            const params = {check: this.check, data: item}
            this.$emit('checkCondition', params)
        },
    },
})
